import React from "react";
import {
    Box,
    H4,
    Grid,
    P,
} from '@saladbob/sassafras'

import { Upload } from "../../types";
import Image from "../media/Image";

type Props = {
    staff: {
        id: string,
        name: string,
        title: string,
        image: Upload,
    },
    depth?: string,
    bgColor?: string,
    txtColor?: string,
    year?: boolean,
    maxWidth?: string,
}


const StaffCard: React.FC<Props> = ({
    staff,
    maxWidth,
    txtColor,
    depth = 'md',
}) => {
    return (
        <Grid 
            columns="1fr"
            rows="min-content 1fr"
            maxWidth={maxWidth}
            width="100%"
            minHeight="auto"
        >
            <Image
                image={staff.image}
                size="card"
                alt={staff.name}
                loading="lazy"
                aspectRatio="1/1"
                rounded="100%"
                depth={depth}
            />
            <Box padding="md" verticalAlign="center" align="center">
                <P font="leader" align="center" color={txtColor || 'black'} mb="0">{staff.name}</P>
                <H4 align="center" color={txtColor || 'black'}>
                    {staff.title}
                </H4>
            </Box>
        </Grid>
    );
}

export default StaffCard;